module.exports = __webpack_public_path__ + "img/icon_futi_01.2bc8f451.png";